<template lang="html">
	<wizard-screen
		:completed="false"
		panelClass="omapi-panel__welcome"
		contentClass="omapi-text-center"
		:navPrev="false"
		:navNext="false"
	>
		<h2>Welcome to the OptinMonster Setup Wizard!</h2>
		<common-alerts id="om-connect-alerts" :alerts="alerts"/>

		<div class="omapi-happy-text">
			You're just minutes away from getting more subscribers, leads and sales from your website. Experience the full power of OptinMonster today!
		</div>
		<div>
			<core-button
				v-if="! isLoading"
				href="#"
				@click.prevent="$bus.$emit('onboardingNextPage')"
				class="omapi-wizard-forward"
				size="monster"
				color="green"
				ref="toFocus"
			>
				New? Claim Your Free Account
			</core-button>
		</div>
		<div v-if="! userId">
			<core-connect-button
				:outputErrors="false"
				:arrow="false"
				:refreshAfter="false"
				@onSuccess="afterConnect"
				type="secondary"
				size="monster"
				class="omapi-wizard-connect-existing"
			>
				Connect Your Existing Account
			</core-connect-button>
		</div>

		<template v-slot:after-card>
			<wizard-exit linkClass="omapi-link-arrow-before">
				Go back to the dashboard
			</wizard-exit>
		</template>
	</wizard-screen>
</template>

<script lang="js">
import { mapGetters, mapState } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	data () {
		return {
			redirectLoading : false,
		}
	},
	mounted () {
		this.$nextTick(() => {
			const getFocusRef = (refs) => {
				while (refs.toFocus && refs.toFocus.$refs) {
					refs = refs.toFocus.$refs
				}

				return refs.toFocus
			}
			this.$nextTick(() => {
				const el = getFocusRef(this.$refs)
				if (el && el.focus) {
					el.focus()
				}
			})
		})
	},
	computed : {
		...mapState([ 'error', 'alerts' ]),
		...mapGetters([ 'userId' ]),
		isLoading () {
			return this.redirectLoading || this.$store.getters.isLoading('connect')
		},
	},
	methods : {
		afterConnect () {
			this.redirectLoading = true
			this.$store.commit('addAlert', {
				message : 'Site connected successfully!',
				type    : 'success',
			})
			setTimeout(() => {
				this.$store.commit('clearAlerts')
				this.$store.commit('addAlert', {
					message : 'Reloading, please wait...',
					type    : 'success',
				})

				const prev = this.$router.getPreviousRoute()
				const prevUrl = prev.name ? (prev.fullPath || prev.path) : false

				if (!prevUrl) {
					this.$router.push({ name: 'dashboard' })
				}

				setTimeout(() => {
					if (prevUrl) {
						window.location.href = prevUrl
					} else {
						window.location.reload()
					}
				}, 200)
			}, 1500)
		},
	},
}
</script>
<style scoped lang="scss">
	.omapi-panel__welcome {
		a.omapi-wizard-forward,
		button.omapi-wizard-forward {
			margin-bottom: 20px;
		}
	}
</style>
